<template>
	<div v-if="recommendData.length > 0" class="other-recommend">
		<h4 class="recommend-title custom-align">You May Also Like</h4>
		<Slick class="recommend-slider recommend-slide text-center" ref="slickRecommend" :options="slideOpts">
			<div v-for="(recommend, index) in recommendData" :key="index" class="item-box">
				<div class="inner">
					<div class="recommend-img-box">
						<a :href="recommend.url">
							<!-- <img src="https://via.placeholder.com/392x392/808080/808080" alt=""> -->
							<new-image :url="recommend.image" :size="'_w392_h392'" :name="recommend.name"></new-image>
						</a>
					</div>
					<div class="recommend-info">
						<div class="item-name">
							<a :href="recommend.url">{{ recommend.name }}</a>
						</div>
						<div class="item-price">
							<span v-if="recommend.sellPrice !== recommend.originPrice" class="d-inline-block mr-2 origin-price">
								TWD. {{ recommend.originPrice }}
							</span>
							<span class="sell-price">NT$ {{ recommend.sellPrice }}</span>
						</div>
					</div>
				</div>
			</div>
		</Slick>
	</div>
</template>

<script>
import NewImage from "@global/components/global/image";
import Slick from "@global/vendors/vue-slick";
import { getShopRecommend } from "@global/helpers/recommend";

import { fireRecommendByCategoryClickEvent, fireRecommendViewGAEventByCategory } from "@global/gtm/product";

export default {
	name: "Recommend",
	props: {
		itemDatas: {
			type: Object,
			default: () => {},
		},
	},
	components: { NewImage, Slick },
	watch: {
		recommendData(data) {
			if (data.length !== 0) {
				fireRecommendViewGAEventByCategory({
					itemListName: `${window.CustomMarketID.split("SZ")[0]} 用戶推薦產品列表`,
					recommendData: this.recommendData,
				});

				this.$nextTick(() => {
					$(".recommend-slider").not(".slick-initialized").slick(this.defaultOptions);

					$(".recommend-slider").on("swipe", (event, slick, direction) => {
						fireRecommendByCategoryClickEvent({
							recommendedData: this.recommendData,
							recommendedMove: direction === "left" ? "推薦商品 More 左滑" : "推薦商品 More 右滑",
							recommendedType: "產品內頁",
							productId: window.CustomMarketID,
							productName: this.itemDatas.Name,
							itemListName: "品牌推薦產品列表",
						});
					});
				});
			}
		},
	},
	data() {
		return {
			recommendData: [],
			slideOpts: {
				arrows: false,
				dots: false,
				speed: 300,
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							arrows: false,
							dots: true,
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
				],
			},
		};
	},
	created() {
		getShopRecommend().then((recommendData) => {
			this.recommendData = recommendData;
		});
	},
};
</script>
